import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import { generateInventoryReservationsSearchParams } from "../../../../utils"
import { SearchPayload } from "../../../search/SearchPayload"
import { InventorySearchItemsResult } from "../../data/model/inventorySearchItemsResult"

export class ReservationService {
    
    static async findReservationsBySearchPayload(
        paginatedSearch : Partial<SearchPayload>) : Promise<InventorySearchItemsResult> {
        const postData = generateInventoryReservationsSearchParams(paginatedSearch)
        const res = await AppContext.getApiClient().post("/listing/search", postData)
        
        if (res.error) {
            throw new Error(res.error.message)
        }
        return res as InventorySearchItemsResult
    }
}


// WEBPACK FOOTER //
// ./src/state/inventory/reservations/service/reservationservice.ts